//libs\featureds\public\clients\src\lib\data-access\clients.service.ts
import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SKIP_ADMIN_AUTH } from '@cardapio-online/http';
import {
  ClientLookupResponse,
  CreateClientRequest,
  CreateClientResponse,
} from '../models/client.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  private readonly http = inject(HttpClient);
  private readonly basePath = '/clients';
  private readonly publicContext = new HttpContext().set(SKIP_ADMIN_AUTH, true);

  getByPhone(phone: string): Observable<ClientLookupResponse> {
    return this.http.get<ClientLookupResponse>(
      `${this.basePath}/phone/${encodeURIComponent(phone)}`,
      {
        context: this.publicContext,
      }
    );
  }

  getById(id: string): Observable<ClientLookupResponse> {
    return this.http.get<ClientLookupResponse>(`${this.basePath}/${id}`, {
      context: this.publicContext,
    });
  }

  create(payload: CreateClientRequest): Observable<CreateClientResponse> {
    return this.http.post<CreateClientResponse>(this.basePath, payload, {
      context: this.publicContext,
    });
  }
}
